export default "__VITE_ASSET__CuXTQhhT__"